import { recordTrack } from '@saucelabs/sl-util-segmentio';

import {
  RIGHT_COLUMN_TAB_COMMANDS,
  RIGHT_COLUMN_TAB_LOGS,
  RIGHT_COLUMN_TAB_METADATA,
} from './ducks/container/constants';

export const LEGACY_PREFIX = 'Test Details';

export const CTA_EVENTS = Object.freeze({
  PLAY_VIDEO: 'cta/play/job-details__test-video',
});

export const NAVIGATION_EVENTS = Object.freeze({
  BREADCRUMBS: Object.freeze({
    BACK_TO_DASHBOARD: 'nav/view/job-details__dashboard',
  }),
  RIGHT_COLUMN_TABS: Object.freeze({
    [RIGHT_COLUMN_TAB_COMMANDS]: 'nav/view/job-details__test-commands',
    [RIGHT_COLUMN_TAB_LOGS]: 'nav/view/job-details__test-logs',
    [RIGHT_COLUMN_TAB_METADATA]: 'nav/view/job-details__test-metadata',
  }),
});

export const JOB_DETAILS_LEGACY_EVENTS = Object.freeze({
  PAGE_OPEN: `${LEGACY_PREFIX} Page Open`,
  ENTERED_FULLSCREEN: `${LEGACY_PREFIX} Entered Fullscreen`,
  KEBAB_MENU_OPENED: `${LEGACY_PREFIX} Kebab Menu Opened`,
});

export const JOB_DETAILS_EVENTS = Object.freeze({
  EXPIRED_ASSETS: 'docs/click/job-details__error-toast__common-error-messages-link',
});

export const JOB_COMMANDS_EVENTS = Object.freeze({
  EXPAND: 'Job Details - Expand Command',
  COLLAPSE: 'Job Details - Collapse Command',
});

export const trackEvent = recordTrack;
export default trackEvent;
